<template>
    <div class="gc-listing">
        <section 
            class="form-card"
            v-for="(user, index) in clubUsers" 
            :key="index"
        >
            <div class="form-card__intro">
                {{ user.id }}
            </div>
            <div class="form-card__actions">
                <v-icon 
                    class="form-card__action" 
                    @click="editClubUser(user.id)"
                >
                    edit
                </v-icon>
            </div>
        </section>
     </div>
</template>
<script>
 
export default {
    name: "ClubUserListing",
    props: {
    clubUsers: {
        type: Array
    }
    },
    data: () => ({
        api: `${process.env.VUE_APP_CLUBSAPI}`,
       
        clubsData: []
    }),
    mounted() {
    },
    methods: {
        editClubUser(userId) {   
            this.$router.push({
                name: "Edit Club User",
                params: {
                    id: userId
                }
            })
            console.log(userId)
        },
    }
}
</script>
 
<style scoped lang='scss'>

.form-card {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 15px 0;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 80px;
    &__intro {
        flex-grow: 1;
        margin: 16px 16px 8px;
    }
    &__actions {
        background-color: #E6E8F1;
        height: 100%;
        padding: 24px 16px;
    }
    &__action {
        margin: 0 8px 0 0;
        i {
            color: #67247c;
        }
    }
}
 
.view-more {
    width: 180px;
    height: 30px;
    background: grey;
}

.header {
    background: #67247c;
    padding: 10px;
    display: flex;
    width: 100%;
    color: white;
    

    .field__intro, .header__actions {
        flex-grow: 1;
        margin: 16px 16px 8px;
        
    }

    .header__actions {
        text-align: center;
    }

}
</style>
 